import React, {FC, ReactElement, useState} from "react";
import {IconButton} from "@material-ui/core";
import CopyIcon from "view/images/CopyIcon";
import CheckCircleOutlinedIcon from "@material-ui/icons/CheckCircleOutlined";
import FlexBox from "view/components/Layout/FlexBox";

type Props = {
  value: string;
  className?: string;
  copyIconColor?: string;
  iconClassName?: string;
  helperText?: ReactElement;
  successIconClassName?: string;
  onClick?: () => void;
};

const ClipboardButton: FC<Props> = ({
  value,
  copyIconColor,
  className,
  iconClassName,
  helperText,
  successIconClassName,
  onClick: propsOnClick,
}) => {
  const copyIcon = <CopyIcon color={copyIconColor} className={iconClassName} />;
  const [icon, setIcon] = useState(copyIcon);
  const [isCopied, setIsCopied] = useState<boolean>(false);

  const onClick = () => {
    navigator.clipboard.writeText(value);
    setIcon(
      <CheckCircleOutlinedIcon
        color="primary"
        className={successIconClassName}
      />
    );
    setIsCopied(true);
    setTimeout(() => {
      setIcon(copyIcon);
      setIsCopied(false);
    }, 3000);
    propsOnClick?.();
  };

  return (
    <FlexBox gap={0.5}>
      <IconButton className={className} onClick={onClick} disabled={isCopied}>
        {icon}
      </IconButton>
      {!!helperText && isCopied && helperText}
    </FlexBox>
  );
};

export default ClipboardButton;
